<div class="fixed right-2 bottom-8 z-40 flex flex-col items-end gap-2 w-full max-w-xs">
  @if (latestCriticalEntry() && !isCenterOpen() && !hasVisibleErrorToast()) {
    <button
      class="w-full min-w-[250px] text-left text-sm rounded-sm px-3 py-2 shadow-lg border border-black/10 bg-red-200 hover:bg-red-300"
      title="Open notification center"
      (click)="toggleCenter()">
      <span class="font-semibold">Attention needed:</span>
      {{ latestCriticalEntry()?.message }}
    </button>
  }

  @for (entry of visibleToasts(); track entry.id; let i = $index) {
    <div
      class="relative text-sm rounded-sm px-2 py-1 flex justify-between items-center min-w-[250px] shadow-lg transition-all duration-300 border border-black/10"
      [ngClass]="{
        'bg-green-200': entry.success,
        'bg-red-200': !entry.success,
      }"
      [style.opacity]="1 - 0.25 * i"
      [style.transform]="'scale(' + (1 - 0.05 * i) + ') translateY(' + 8 * i + 'px)'">
      <span class="flex-1">{{ entry.timestamp | date: 'HH:mm' }}: {{ entry.message }}</span>
      <button class="ml-2 p-1 rounded-sm bg-white/70 hover:bg-white" title="Dismiss" (click)="dismiss(entry.id)">
        <i class="fas fa-times"></i>
      </button>
      @if (!entry.sticky) {
        <div class="progress-bar absolute left-0 bottom-0 h-1 bg-black/20"></div>
      }
    </div>
  }

  @if (queuedToastCount() > 0) {
    <button
      class="w-full min-w-[250px] text-sm rounded-sm px-2 py-1 shadow-lg transition-all duration-300 border border-black/10 bg-brand-100 hover:bg-brand-200 text-black"
      title="Open notification center"
      (click)="toggleCenter()">
      +{{ queuedToastCount() }} more message{{ queuedToastCount() > 1 ? 's' : '' }}
    </button>
  }

  <button
    class="relative h-10 w-10 rounded-full shadow-lg transition-all duration-300 border border-black/10 bg-white hover:bg-gray-100 text-black flex items-center justify-center"
    title="Open notification center"
    (click)="toggleCenter()">
    <i class="fas fa-bell"></i>
    @if (unreadCount() > 0) {
      <span
        class="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 text-[10px] rounded-full bg-red-500 text-white flex items-center justify-center">
        {{ unreadCount() }}
      </span>
    }
  </button>

  @if (isCenterOpen()) {
    <div
      class="w-full min-w-[300px] max-w-sm max-h-[60vh] overflow-y-auto rounded-md border border-black/15 bg-white shadow-2xl">
      <div class="sticky top-0 bg-white border-b border-black/10 px-3 py-2 flex items-center justify-between">
        <span class="text-sm font-semibold">Notifications</span>
        <div class="flex items-center gap-2">
          <button
            class="text-xs px-2 py-1 rounded-sm bg-gray-100 hover:bg-gray-200"
            title="Clear all messages"
            (click)="clearAll()">
            Clear all
          </button>
          <button class="text-xs px-2 py-1 rounded-sm bg-gray-100 hover:bg-gray-200" (click)="closeCenter()">
            Close
          </button>
        </div>
      </div>
      <div class="p-2 space-y-2">
        @for (entry of recentHistory(); track entry.id) {
          <div
            class="text-sm rounded-sm px-2 py-2 border border-black/10"
            [ngClass]="{
              'bg-green-100': entry.success,
              'bg-red-100': !entry.success,
              'opacity-70': entry.read,
            }">
            <div class="text-xs opacity-70 mb-1">{{ entry.timestamp | date: 'HH:mm:ss' }}</div>
            <div>{{ entry.message }}</div>
          </div>
        }
        @if (recentHistory().length === 0) {
          <div class="text-sm text-gray-500 px-1 py-2">No notifications yet.</div>
        }
      </div>
    </div>
  }
</div>
